module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/point01_01_winter-415ab49b0757b1374fa856d6171370b0.jpg";